import * as React from 'react'
import { StatusDropdownConnected } from './StatusDropdownConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TASK_A_ID } from 'mockState'

export const StatusDropdownExamples = () => {
  return (
    <div className="StatusDropdownExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <StatusDropdownConnected taskId={MOCK_TASK_A_ID} />
      </Provider>
    </div>
  )
}
